var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_html.js
// module id = 1537
// module chunks = 25